import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card4 from "../Images/Profiles/Godfrey.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function GodfreyMuhwezi() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Godfrey Muhwezi - Director"
        description="Mr. Godfrey Muhwezi is the Director at CIRCODU with a Master of Science degree in Chemistry and a Bachelor of Science degree with a specialized focus on Education (Chemistry/Biology)."
        keywords="Godfrey Muhwezi, Director, CIRCODU, Master of Science, Bachelor of Science, Chemistry, Education"
        url="/godfrey-muhwezi"
        image={Card4}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Godfrey Muhwezi</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Godfrey Muhwezi
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card4} alt="Mr. Godfrey Muhwezi" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Godfrey Muhwezi</h1>
                <p className="profile-card__role">Director</p>
                <p className="profile-card__sub-role">
                  Environmental Chemist and Emissions Expert
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Godfrey is concurrently pursuing his doctoral studies in
                  Chemistry and serving as a Chemistry Doctoral Candidate at
                  Kyambogo University.
                </p>
                <p>
                  His educational background comprises a Master of Science
                  degree in Chemistry from Makerere University and a Bachelor of
                  Science degree with a specialized focus on Education
                  (Chemistry/Biology) from Mbarara University of Science and
                  Technology.
                </p>
                <p>
                  Currently, Godfrey holds a teaching position within the
                  Chemistry Department at Muni University. In addition to his
                  academic role, he has contributed significantly to research
                  initiatives. Notably, he was affiliated with the International
                  Centre for Research in Agroforestry (ICRAF) in Kabale, Uganda,
                  where he served as a diligent Researcher.
                </p>
                <p>
                  Godfrey's academic and professional interests are centered
                  around Environmental and Analytical Chemistry. His expertise
                  also extends to the field of Emissions and Indoor Air
                  Pollution measurement, showcasing his commitment to advancing
                  knowledge in crucial environmental domains. As part of his
                  Doctoral Studies, he is immersed in a compelling exploration
                  of emerging Organic Pollutants in Indoor Air and Dust,
                  specifically within the context of Central Uganda.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/muhwezi-godfrey-a20abb29/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/GodfreyMuhwez"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/muhwezi.godfrey/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256772384731"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:godfrey.muhwezi@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GodfreyMuhwezi;
